import { onMounted, onUnmounted } from "vue";

export default function useHoldScroll() {
  const setHold = () => {
    document.body.style.overflow = "hidden";
    document.body.style.top = `-${window.scrollY}px`;
  };
  const unsetHold = () => {
    const scrollY = document.body.style.top;
    document.body.style.overflow = "";
    document.body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  };

  const fetchHoldAction = () => {
    onMounted(() => setHold());
    onUnmounted(() => unsetHold());
  };

  return {
    setHold,
    unsetHold,
    fetchHoldAction,
  };
}
